"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateUserOptions = void 0;
const create_ac_1 = require("@app/ac/util/create-ac");
const ui_1 = require("@app/component/ui");
const me_1 = require("@app/reducer/me");
const util_1 = require("@app/util");
const promises_1 = require("@app/util/promises");
const react_1 = __importDefault(require("react"));
const react_hot_toast_1 = __importDefault(require("react-hot-toast"));
const user_option_set_1 = require("../requests/user-option-set");
exports.updateUserOptions = (0, create_ac_1.createAC)(async (dispatch, { form, options }) => {
    const _options = Object.entries(form).map((entry) => ({
        key: entry[0],
        value: entry[1].toString(),
    }));
    const filteredOptions = _options.filter((_opt) => {
        const existingOption = options.find((opt) => opt.key === _opt.key);
        if ((0, util_1.isDefined)(existingOption) && existingOption.value === _opt.value)
            return false;
        return true;
    });
    const requests = filteredOptions.map(async (opt) => await (0, user_option_set_1.mutateUserOptionSet)(opt));
    const settledRequests = await Promise.allSettled(requests);
    const values = settledRequests
        .filter(promises_1.isFulfilled)
        .map((response) => response.value)
        .filter(util_1.isDefined);
    dispatch((0, me_1.updatedUserOptions)(values));
    react_hot_toast_1.default.custom(() => (react_1.default.createElement(ui_1.Alert, { type: ui_1.Alert.TYPES.SUCCESS, text: (0, util_1.t)('SUCCESS_MESSAGE.employeeProfile') })));
});
